import React from 'react';

import { Loader2 } from 'lucide-react';

const LoaderSkeleton = () => {
  return (
    <div className="card max-w-2xl mx-auto px-8 py-12 text-center progress-card">
      <Loader2 className="h-12 w-12 mx-auto animate-spin text-primary-600"/>
      
      <div className="text-xl font-semibold mt-4 mb-2 progress-title">We’re preparing your Reputation Audit Report…</div>
      
      <div className="text-gray-500 mb-5">This will only take a few seconds.</div>
      
      <ul className="text-left space-y-2 text-gray-600 progress-list mt-8 px-12 ">
        <li>• Calculating your <b>Reputation Score</b></li>
        <li>• Analyzing <b>Net Promoter Score</b></li>
        <li>• Gathering <b>Review Insights</b></li>
      </ul>
    </div>
  );
};

export default LoaderSkeleton;
